import React from 'react';
import { func } from 'prop-types';
import { Close } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';

import styles from './styles.scss';

const ModalCloseButton = ({ onClose }) => (
  <IconButton classes={{ root: styles.modalCloseButton }} onClick={onClose}>
    <Close />
  </IconButton>
);

ModalCloseButton.propTypes = {
  onClose: func.isRequired,
};

export default ModalCloseButton;
